import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import DataBlock from '../data-block/DataBlock';
import SectionWrapper from './section-wrapper/SectionWrapper';
import BenchmarkFilters from './benchmark-filters/BenchmarkFilters';
import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import BenchmarksNodeList from './benchmarks-node-list/BenchmarksNodeList';
import { saveBenchmark } from '../../../redux/resonance/resonanceReducer';
import useBenchmarkValue from './hooks/useBenchmarkValue';

import scss from './Benchmarks.module.scss';

function Benchmarks() {
  const { t } = useTranslation('resonance');
  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  const [localNodes, setLocalNodes] = useState([]);

  const benchmarkNodes = useSelector((state) => state.resonance.benchmarkNodes);

  const { benchmarkValue, isLoading } = useBenchmarkValue({ benchmarkNodes: localNodes });

  const handleSelectNode = (node) => {
    setLocalNodes((prevNodes) => {
      const isExisted = prevNodes.some(({ id }) => node.id === id);
      const newNodes = isExisted ? prevNodes.filter(({ id }) => id !== node.id) : [...prevNodes, node];

      return newNodes;
    });
  };

  const handleRemoveAllNodes = () => {
    setLocalNodes([]);
  };

  const handleSaveBenchmark = () => {
    dispatch(saveBenchmark({ benchmark: benchmarkValue, benchmarkNodes: localNodes }));
  };

  useEffect(() => {
    setLocalNodes(benchmarkNodes);
  }, [benchmarkNodes]);

  return (
    <div className={scss.pageWrapper}>
      <DataBlock />

      <SectionWrapper result={benchmarkValue} isLoading={isLoading}>
        <BenchmarkFilters search={search} onSearch={setSearch} onRemoveAll={handleRemoveAllNodes} />

        <BenchmarksNodeList search={search} selectedNodes={localNodes} onSelectNode={handleSelectNode} />

        <div className={scss.actions}>
          <CommonButton styleColor={BUTTON_STYLES.PRIMARY} onClick={handleSaveBenchmark} maxWidth={200}>
            {t('submit')}
          </CommonButton>
        </div>
      </SectionWrapper>
    </div>
  );
}

export default Benchmarks;
